import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';

const PageError = () => {
  return (
    <Flex
      justify='center'
      align='center'
      h='100%'
      mt='7rem'>
      <Box
        p={4}
        bg='red.100'
        borderRadius='md'>
        <Text>Loading failed, try refreshing the page or contact support.</Text>
      </Box>
    </Flex>
  );
};

export default PageError;
